// import { motion } from "framer-motion";
// import { Target, Eye, Zap, Globe, Users, Award } from "react-feather";
// import PageShell from "../../components/premium/layout/PageShell";
// import PageHero from "../../components/premium/layout/PageHero";
// import SectionHeading from "../../components/premium/layout/SectionHeading";
// import AnimatedCounter from "../../components/premium/AnimatedCounter";
// import MagneticButton from "../../components/premium/hero/MagneticButton";

// const values = [
//   { icon: Award, title: "Innovation", desc: "Cutting-edge solutions for real-world challenges." },
//   { icon: Users, title: "Community", desc: "Empowering learners and businesses across India." },
//   { icon: Zap, title: "Quality", desc: "Enterprise-grade products you can trust." },
//   { icon: Globe, title: "Impact", desc: "Technology that creates positive social change." },
// ];

// export default function AboutPage() {
//   return (
//     <PageShell>
//       <PageHero
//         badge="About EPT Pravahaa"
//         title="Empowering India with"
//         highlight="Technology"
//         subtitle="We build smart mobility, digital education, and scalable software that transforms how people learn, move, and grow."
//       />

//       <section className="py-16 lg:py-24 premium-section-alt">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid md:grid-cols-2 gap-8">
//             {[
//               { icon: Target, title: "Mission", text: "Deliver transformative technology through mobility, education, and software excellence." },
//               { icon: Eye, title: "Vision", text: "Become India's most trusted platform for smart transportation and digital learning." },
//             ].map((item, i) => (
//               <motion.div
//                 key={item.title}
//                 initial={{ opacity: 0, y: 24 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 className="premium-glass premium-glass-glow rounded-2xl p-8"
//               >
//                 <div className="w-12 h-12 rounded-xl bg-[#2563EB]/30 flex items-center justify-center text-[#60a5fa] mb-4">
//                   <item.icon size={24} />
//                 </div>
//                 <h3 className="text-xl font-bold text-white">{item.title}</h3>
//                 <p className="mt-3 text-white/60 leading-relaxed">{item.text}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="py-16 lg:py-24">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <SectionHeading badge="Our Values" title="What Drives Us" />
//           <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {values.map((v, i) => (
//               <motion.div
//                 key={v.title}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.08 }}
//                 className="premium-glass rounded-2xl p-6 text-center hover:border-[#F5C044]/30 transition-colors"
//               >
//                 <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-[#2563EB] to-[#1d4ed8] flex items-center justify-center text-white mb-4">
//                   <v.icon size={26} />
//                 </div>
//                 <h3 className="font-bold text-white">{v.title}</h3>
//                 <p className="mt-2 text-sm text-white/55">{v.desc}</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="py-16 premium-section-alt">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8 premium-glass rounded-3xl p-8 lg:p-12">
//             <AnimatedCounter end={2} suffix="+" label="Products" />
//             <AnimatedCounter end={50} suffix="+" label="Projects" />
//             <AnimatedCounter end={100} suffix="%" label="Commitment" />
//             <div className="text-center">
//               <div className="text-4xl md:text-5xl font-bold text-white">24/7</div>
//               <p className="mt-2 text-sm text-white/60 uppercase tracking-widest">Support</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section className="py-16 text-center">
//         <MagneticButton to="/contact" variant="primary">Partner With Us</MagneticButton>
//       </section>
//     </PageShell>
//   );
// }


import { motion } from "framer-motion";
import { Target, Eye, Zap, Globe, Users, Award } from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";
import SectionHeading from "../../components/premium/layout/SectionHeading";
import AnimatedCounter from "../../components/premium/AnimatedCounter";
import MagneticButton from "../../components/premium/hero/MagneticButton";

// images
import traning from "../../assets/images/traning.jpg"; // Placeholder
import cab from "../../assets/images/cab.jpg"; // Placeholder
// import webapp from "../../assets/images/web-app.jpg"; // Placeholder

const values = [
  { icon: Award, title: "Innovation", desc: "Cutting-edge solutions for real-world challenges." },
  { icon: Users, title: "Community", desc: "Empowering learners and businesses across India." },
  { icon: Zap, title: "Quality", desc: "Enterprise-grade products you can trust." },
  { icon: Globe, title: "Impact", desc: "Technology that creates positive social change." },
];

const team = [
  { name: "KRANTHI KIRAN", role: "MANAGING DIRECTOR", image: traning },
  { name: "HIMASREE THOTA", role: "CEO", image: cab },
  // { name: "CHALLA KIRAN", role: "CTO", image: webapp },
];

export default function AboutPage() {
  return (
    <PageShell>
      <PageHero
        badge="About EPT Pravahaa"
        title="Empowering India with"
        highlight="Technology"
        subtitle="We build smart mobility, digital education, and scalable software that transforms how people learn, move, and grow."
      />

      {/* Mission & Vision Section */}
      <section className="py-16 lg:py-24 premium-section-alt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {[
              { icon: Target, title: "Mission", text: "Deliver transformative technology through mobility, education, and software excellence." },
              { icon: Eye, title: "Vision", text: "Become India's most trusted platform for smart transportation and digital learning." },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="premium-glass premium-glass-glow rounded-2xl p-8"
              >
                <div className="w-12 h-12 rounded-xl bg-[#2563EB]/30 flex items-center justify-center text-[#60a5fa] mb-4">
                  <item.icon size={24} />
                </div>
                <h3 className="text-xl font-bold text-white">{item.title}</h3>
                <p className="mt-3 text-white/60 leading-relaxed">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading badge="Our Values" title="What Drives Us" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="premium-glass rounded-2xl p-6 text-center hover:border-[#F5C044]/30 transition-colors"
              >
                <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-[#2563EB] to-[#1d4ed8] flex items-center justify-center text-white mb-4">
                  <v.icon size={26} />
                </div>
                <h3 className="font-bold text-white">{v.title}</h3>
                <p className="mt-2 text-sm text-white/55">{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Champions of our success story Section */}
      <section className="py-16 lg:py-24 premium-section-alt relative overflow-hidden">
        {/* Subtle background element mimicking the curve in the image */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#F5C044]/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
            
            {/* Left Column: Text Content */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Champions of our <br className="hidden md:block" /> success story
              </h2>
              {/* Golden underline accent */}
              <div className="w-16 h-1 bg-[#F5C044] mb-6 rounded-full" />
              
              <p className="text-white/60 leading-relaxed text-lg max-w-lg">
                EPT Pravahaa has come a long way since its inception. With a lot of hardwork and perseverance we have made a place for ourselves in the market. As a brand and as a service, it is our constant endeavour to redefine ourselves and empower the future.
              </p>
            </motion.div>

            {/* Right Column: Team Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8">
              {team.map((member, i) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15 }}
                  className="text-center group"
                >
                  <div className="relative inline-block mb-4">
                    {/* Golden accent shape behind image */}
                    <div className="absolute inset-0 bg-[#F5C044] rounded-2xl rounded-tr-none transform -rotate-6 transition-transform group-hover:rotate-0 -z-10" />
                    
                    <img 
                      src={member.image} 
                      alt={member.name} 
                      className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-2xl rounded-tr-none border-4 border-[#040d18] relative z-10 transition-transform group-hover:-translate-y-1"
                    />
                  </div>
                  <h4 className="font-bold text-white text-sm md:text-base">{member.name}</h4>
                  <p className="text-white/55 text-xs md:text-sm mt-1">{member.role}</p>
                </motion.div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 premium-glass rounded-3xl p-8 lg:p-12">
            <AnimatedCounter end={2} suffix="+" label="Products" />
            <AnimatedCounter end={50} suffix="+" label="Projects" />
            <AnimatedCounter end={100} suffix="%" label="Commitment" />
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white">24/7</div>
              <p className="mt-2 text-sm text-white/60 uppercase tracking-widest">Support</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 text-center">
        <MagneticButton to="/contact" variant="primary">Partner With Us</MagneticButton>
      </section>
    </PageShell>
  );
}
